import React, {Fragment, useState} from "react";
import {Button} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {ConfirmationPrompt} from "../ui/ConfirmationPrompt";
import {Organization} from "../../models/organization";
import {SupportedUnit} from "../../models/domain-of-responsibility.models";

type SupportedUnitActionsProps = {
	organization: Organization;
	supportedUnits: SupportedUnit[];
	onRemove: (supportedUnit: SupportedUnit) => void;
};

const SupportedUnitActions = ({organization, supportedUnits, onRemove}: SupportedUnitActionsProps) => {
	const {t} = useTranslation();
	const [showConfirmation, setShowConfirmation] = useState(false);

	const onRemoveSupportedOrganization = () => {
		const supportedUnit = supportedUnits.find((u: SupportedUnit) => u.organizationId === organization.id);
		if (supportedUnit) {
			onRemove(supportedUnit);
		}
	};

	return <Fragment>
		<Button color="primary" size="small" onClick={() => setShowConfirmation(true)}>
			{t('_Common.Labels.Remove')}
		</Button>
		<ConfirmationPrompt
			title={t('SupportUnit.Actions.RemoveOrganization.Title')}
			description={t('SupportUnit.Actions.RemoveOrganization.Description')}
			open={showConfirmation}
			disable={false}
			onCancel={() => setShowConfirmation(false)}
			onConfirm={() => {
				onRemoveSupportedOrganization();
				setShowConfirmation(false);
			}}
			confirmationButtonKey={'_Common.Labels.Confirm'}
		/>
	</Fragment>;
};

export default SupportedUnitActions;

